import React, { type FC } from 'react';
import type { OtpChannelProps } from './otp-channel.types';
import { MenuItem } from '../menu-item';
import { useOtpChannelView } from './use-otp-channel-view.hook';
import { Button } from '../../atoms/button';
import styles from './otp-channel.module.css';

export const OtpChannel: FC<OtpChannelProps> = ({ containerClassName, channel, textProps, primaryIconProps }) => {
    const { otpChannelIconProps, labelProps, rightIconProps, containerStyles } = useOtpChannelView({
        channel,
        textProps,
        primaryIconProps,
        containerClassName,
    });

    return (
        <Button
            showIf={!!channel?.onPress}
            onClick={channel?.onPress}
            className={containerStyles}
            contentClassName={styles.contentWrapper}
        >
            <MenuItem
                containerClassName={styles.otpChannelItem}
                leadingIconProps={otpChannelIconProps}
                label={channel?.label}
                labelProps={labelProps}
                trailingIconProps={rightIconProps}
            />
        </Button>
    );
};
